import { createAction } from 'redux-starter-kit';


export const putInspection = createAction('PUT_LIST_INSPECTION');
export const putInspections = createAction('PUT_LIST_INSPECTIONS');
export const putAllInspections = createAction('PUT_LIST_INSPECTIONS_ALL');
